;(function ($) {
  $(document).ready(function () {
    function siteInit() {
      // new Swiper( '#key-findings .swiper', {
      // 	loop: true,
      // 	slidesPerView: 'auto'
      // });

      $("#full-data-table").DataTable({
        searching: false,
        paging: false,
        info: false,
        order: [[7, "desc"]],
        columnDefs: [
          {
            targets: [0, 1, 2],
            orderable: false,
          },
        ],
        responsive: true,
      })

      $(".table .see-more").on("click", function (e) {
        var $this = $(this),
          wrap = $this.parents(".table")

        $this.hide()
        wrap.find("tr.d-none").removeClass("d-none")
        e.preventDefault()
      })

      $("#key-findings .copy").on("click", function (e) {
        e.preventDefault()

        var copyText = $(this).parents(".item").find(".item__text").text()

        if (copyText) {
          navigator.clipboard.writeText(copyText)
        }
      })
    }

    siteInit()

    function keyFindings() {
      const setSpacing = () => {
        var firstHeight = $("#key-findings .item--1").height()

        $("#key-findings .item--2").css({
          marginTop: firstHeight + "px",
        })
      }

      setSpacing()

      $(window).resize(function () {
        setSpacing()
      })
    }

    keyFindings()

    function statesDrink() {
      const usData = [
        {
          state: "Hawaii",
          consumption: "15114851",
          cup_per_capita_per_day: "2.7",
          number_of_coffee_cups_in_a_lifetime: "57159",
          coffee_price: "4.67",
          lifetime_pay: "266933",
        },
        {
          state: "Alaska",
          consumption: "7302379",
          cup_per_capita_per_day: "2.6",
          number_of_coffee_cups_in_a_lifetime: "55042",
          coffee_price: "4.73",
          lifetime_pay: "260349",
        },
        {
          state: "Oregon",
          consumption: "38149563",
          cup_per_capita_per_day: "2.3",
          number_of_coffee_cups_in_a_lifetime: "48691",
          coffee_price: "4.05",
          lifetime_pay: "197199",
        },
        {
          state: "Washington",
          consumption: "69667921",
          cup_per_capita_per_day: "2.3",
          number_of_coffee_cups_in_a_lifetime: "48691",
          coffee_price: "4.44",
          lifetime_pay: "216188",
        },
        {
          state: "New Hampshire",
          consumption: "11624744",
          cup_per_capita_per_day: "2.1",
          number_of_coffee_cups_in_a_lifetime: "44457",
          coffee_price: "3.65",
          lifetime_pay: "162268",
        },
        {
          state: "Vermont",
          consumption: "5047233",
          cup_per_capita_per_day: "2",
          number_of_coffee_cups_in_a_lifetime: "42340",
          coffee_price: "3.62",
          lifetime_pay: "153271",
        },
        {
          state: "Maine",
          consumption: "10550864",
          cup_per_capita_per_day: "2",
          number_of_coffee_cups_in_a_lifetime: "42340",
          coffee_price: "3.52",
          lifetime_pay: "149037",
        },
        {
          state: "Rhode Island",
          consumption: "8188330",
          cup_per_capita_per_day: "1.9",
          number_of_coffee_cups_in_a_lifetime: "40223",
          coffee_price: "4.14",
          lifetime_pay: "166523",
        },
        {
          state: "Montana",
          consumption: "7785625",
          cup_per_capita_per_day: "1.8",
          number_of_coffee_cups_in_a_lifetime: "38106",
          coffee_price: "4.04",
          lifetime_pay: "153948",
        },
        {
          state: "Massachusetts",
          consumption: "48163487",
          cup_per_capita_per_day: "1.8",
          number_of_coffee_cups_in_a_lifetime: "38106",
          coffee_price: "4.12",
          lifetime_pay: "156997",
        },
        {
          state: "New Jersey",
          consumption: "63734738",
          cup_per_capita_per_day: "1.8",
          number_of_coffee_cups_in_a_lifetime: "38106",
          coffee_price: "3.9",
          lifetime_pay: "148613",
        },
        {
          state: "Wyoming",
          consumption: "3785425",
          cup_per_capita_per_day: "1.7",
          number_of_coffee_cups_in_a_lifetime: "35989",
          coffee_price: "3.85",
          lifetime_pay: "138558",
        },
        {
          state: "California",
          consumption: "245381424",
          cup_per_capita_per_day: "1.6",
          number_of_coffee_cups_in_a_lifetime: "33872",
          coffee_price: "4.32",
          lifetime_pay: "146327",
        },
        {
          state: "Colorado",
          consumption: "35062160",
          cup_per_capita_per_day: "1.5",
          number_of_coffee_cups_in_a_lifetime: "31755",
          coffee_price: "4.27",
          lifetime_pay: "135594",
        },
        {
          state: "Connecticut",
          consumption: "20886953",
          cup_per_capita_per_day: "1.5",
          number_of_coffee_cups_in_a_lifetime: "31755",
          coffee_price: "4.25",
          lifetime_pay: "134959",
        },
        {
          state: "Idaho",
          consumption: "10524017",
          cup_per_capita_per_day: "1.4",
          number_of_coffee_cups_in_a_lifetime: "29638",
          coffee_price: "4.34",
          lifetime_pay: "128629",
        },
        {
          state: "New York",
          consumption: "106152971",
          cup_per_capita_per_day: "1.4",
          number_of_coffee_cups_in_a_lifetime: "29638",
          coffee_price: "3.9",
          lifetime_pay: "115588",
        },
        {
          state: "Utah",
          consumption: "16215578",
          cup_per_capita_per_day: "1.2",
          number_of_coffee_cups_in_a_lifetime: "25404",
          coffee_price: "4.69",
          lifetime_pay: "119145",
        },
        {
          state: "Pennsylvania",
          consumption: "61425897",
          cup_per_capita_per_day: "1.2",
          number_of_coffee_cups_in_a_lifetime: "25404",
          coffee_price: "3.75",
          lifetime_pay: "95265",
        },
        {
          state: "Michigan",
          consumption: "47062761",
          cup_per_capita_per_day: "1.2",
          number_of_coffee_cups_in_a_lifetime: "25404",
          coffee_price: "3.99",
          lifetime_pay: "101362",
        },
        {
          state: "New Mexico",
          consumption: "9852843",
          cup_per_capita_per_day: "1.2",
          number_of_coffee_cups_in_a_lifetime: "25404",
          coffee_price: "4.02",
          lifetime_pay: "102124",
        },
        {
          state: "Wisconsin",
          consumption: "27330229",
          cup_per_capita_per_day: "1.2",
          number_of_coffee_cups_in_a_lifetime: "25404",
          coffee_price: "3.72",
          lifetime_pay: "94503",
        },
        {
          state: "Delaware",
          consumption: "4671375",
          cup_per_capita_per_day: "1.2",
          number_of_coffee_cups_in_a_lifetime: "25404",
          coffee_price: "3.89",
          lifetime_pay: "98822",
        },
        {
          state: "Illinois",
          consumption: "56486052",
          cup_per_capita_per_day: "1.2",
          number_of_coffee_cups_in_a_lifetime: "25404",
          coffee_price: "3.85",
          lifetime_pay: "97805",
        },
        {
          state: "Nevada",
          consumption: "14175207",
          cup_per_capita_per_day: "1.1",
          number_of_coffee_cups_in_a_lifetime: "23287",
          coffee_price: "4.61",
          lifetime_pay: "107353",
        },
        {
          state: "Maryland",
          consumption: "26820136",
          cup_per_capita_per_day: "1.1",
          number_of_coffee_cups_in_a_lifetime: "23287",
          coffee_price: "4",
          lifetime_pay: "93148",
        },
        {
          state: "North Dakota",
          consumption: "3382720",
          cup_per_capita_per_day: "1.1",
          number_of_coffee_cups_in_a_lifetime: "23287",
          coffee_price: "3.83",
          lifetime_pay: "89189",
        },
        {
          state: "Minnesota",
          consumption: "24779765",
          cup_per_capita_per_day: "1.1",
          number_of_coffee_cups_in_a_lifetime: "23287",
          coffee_price: "3.97",
          lifetime_pay: "92449",
        },
        {
          state: "Kansas",
          consumption: "12671776",
          cup_per_capita_per_day: "1.1",
          number_of_coffee_cups_in_a_lifetime: "23287",
          coffee_price: "3.85",
          lifetime_pay: "89655",
        },
        {
          state: "Iowa",
          consumption: "13772502",
          cup_per_capita_per_day: "1.1",
          number_of_coffee_cups_in_a_lifetime: "23287",
          coffee_price: "3.67",
          lifetime_pay: "85463",
        },
        {
          state: "Arizona",
          consumption: "30874030",
          cup_per_capita_per_day: "1.1",
          number_of_coffee_cups_in_a_lifetime: "23287",
          coffee_price: "4.3",
          lifetime_pay: "100134",
        },
        {
          state: "Florida",
          consumption: "92917408",
          cup_per_capita_per_day: "1.1",
          number_of_coffee_cups_in_a_lifetime: "23287",
          coffee_price: "3.9",
          lifetime_pay: "90819",
        },
        {
          state: "Ohio",
          consumption: "47948712",
          cup_per_capita_per_day: "1.1",
          number_of_coffee_cups_in_a_lifetime: "23287",
          coffee_price: "3.62",
          lifetime_pay: "84299",
        },
        {
          state: "Virginia",
          consumption: "35357477",
          cup_per_capita_per_day: "1",
          number_of_coffee_cups_in_a_lifetime: "21170",
          coffee_price: "4.21",
          lifetime_pay: "89126",
        },
        {
          state: "Missouri",
          consumption: "25101929",
          cup_per_capita_per_day: "1",
          number_of_coffee_cups_in_a_lifetime: "21170",
          coffee_price: "3.82",
          lifetime_pay: "80869",
        },
        {
          state: "Oklahoma",
          consumption: "15598097",
          cup_per_capita_per_day: "1",
          number_of_coffee_cups_in_a_lifetime: "21170",
          coffee_price: "3.9",
          lifetime_pay: "82563",
        },
        {
          state: "Nebraska",
          consumption: "7490308",
          cup_per_capita_per_day: "1",
          number_of_coffee_cups_in_a_lifetime: "21170",
          coffee_price: "3.99",
          lifetime_pay: "84468",
        },
        {
          state: "Indiana",
          consumption: "25799951",
          cup_per_capita_per_day: "1",
          number_of_coffee_cups_in_a_lifetime: "21170",
          coffee_price: "3.85",
          lifetime_pay: "81505",
        },
        {
          state: "South Dakota",
          consumption: "3382720",
          cup_per_capita_per_day: "1",
          number_of_coffee_cups_in_a_lifetime: "21170",
          coffee_price: "4.21",
          lifetime_pay: "89126",
        },
        {
          state: "North Carolina",
          consumption: "39303983",
          cup_per_capita_per_day: "0.9",
          number_of_coffee_cups_in_a_lifetime: "19053",
          coffee_price: "3.74",
          lifetime_pay: "71258",
        },
        {
          state: "Tennessee",
          consumption: "24967694",
          cup_per_capita_per_day: "0.9",
          number_of_coffee_cups_in_a_lifetime: "19053",
          coffee_price: "3.88",
          lifetime_pay: "73926",
        },
        {
          state: "Texas",
          consumption: "103709895",
          cup_per_capita_per_day: "0.9",
          number_of_coffee_cups_in_a_lifetime: "19053",
          coffee_price: "4.02",
          lifetime_pay: "76593",
        },
        {
          state: "West Virginia",
          consumption: "6094265",
          cup_per_capita_per_day: "0.9",
          number_of_coffee_cups_in_a_lifetime: "19053",
          coffee_price: "3.6",
          lifetime_pay: "68591",
        },
        {
          state: "Arkansas",
          consumption: "10389782",
          cup_per_capita_per_day: "0.9",
          number_of_coffee_cups_in_a_lifetime: "19053",
          coffee_price: "3.96",
          lifetime_pay: "75450",
        },
        {
          state: "Louisiana",
          consumption: "15544403",
          cup_per_capita_per_day: "0.9",
          number_of_coffee_cups_in_a_lifetime: "19053",
          coffee_price: "3.79",
          lifetime_pay: "72211",
        },
        {
          state: "South Carolina",
          consumption: "17450539",
          cup_per_capita_per_day: "0.8",
          number_of_coffee_cups_in_a_lifetime: "16936",
          coffee_price: "3.76",
          lifetime_pay: "63679",
        },
        {
          state: "Kentucky",
          consumption: "14202054",
          cup_per_capita_per_day: "0.8",
          number_of_coffee_cups_in_a_lifetime: "16936",
          coffee_price: "3.72",
          lifetime_pay: "63002",
        },
        {
          state: "Georgia",
          consumption: "33478188",
          cup_per_capita_per_day: "0.8",
          number_of_coffee_cups_in_a_lifetime: "16936",
          coffee_price: "4.15",
          lifetime_pay: "70284",
        },
        {
          state: "Alabama",
          consumption: "15222239",
          cup_per_capita_per_day: "0.8",
          number_of_coffee_cups_in_a_lifetime: "16936",
          coffee_price: "4.08",
          lifetime_pay: "69099",
        },
        {
          state: "Mississippi",
          consumption: "8456800",
          cup_per_capita_per_day: "0.7",
          number_of_coffee_cups_in_a_lifetime: "14819",
          coffee_price: "4.12",
          lifetime_pay: "61054",
        },
      ]

      if ($("#consumption-table").length) {
        var usData1 = usData.sort(function (a, b) {
          return b.consumption - a.consumption
        })

        $("#consumption-table").DataTable({
          searching: false,
          paging: false,
          info: false,
          order: [[2, "desc"]],
          columnDefs: [
            {
              targets: [0, 1],
              orderable: false,
            },
          ],
          scrollY: 502,
          scrollCollapse: true,
          data: usData1,
          columns: [
            {
              data: null,
              render: function (data, type, full, meta) {
                var index = meta.row + 1
                var color = "16893C"
                var value = parseFloat(data.consumption)

                if (value > 1 * 1e8) {
                  color = "F9491B"
                } else if (value >= 50 * 1e6 && value <= 1 * 1e8) {
                  color = "FC8D1C"
                } else if (value >= 20 * 1e6 && value < 50 * 1e6) {
                  color = "F9B609"
                } else if (value >= 10 * 1e6 && value < 20 * 1e6) {
                  color = "91C439"
                }

                return '<span class="dot" style="--color: #' + color + '">' + index + "</span>"
              },
            },
            { data: "state" },
            {
              data: "consumption",
              render: $.fn.dataTable.render.number(",", ".", 0, ""),
            },
          ],
          drawCallback: function () {
            new PerfectScrollbar("#consumption-table_wrapper .dataTables_scrollBody", {
              wheelSpeed: 2,
              wheelPropagation: true,
            })
          },
        })
      }

      if ($("#daily-cup-per-capita-table").length) {
        var usData2 = usData.sort(function (a, b) {
          return b.cup_per_capita_per_day - a.cup_per_capita_per_day
        })

        $("#daily-cup-per-capita-table").DataTable({
          searching: false,
          paging: false,
          info: false,
          order: [[2, "desc"]],
          columnDefs: [
            {
              targets: [0, 1],
              orderable: false,
            },
          ],
          scrollY: 502,
          scrollCollapse: true,
          data: usData2,
          columns: [
            {
              data: null,
              render: function (data, type, full, meta) {
                var index = meta.row + 1
                var color = "16893C"
                var value = parseFloat(data.cup_per_capita_per_day)

                if (value > 2) {
                  color = "F9491B"
                } else if (value >= 1 && value <= 2) {
                  color = "F9B609"
                }

                return '<span class="dot" style="--color: #' + color + '">' + index + "</span>"
              },
            },
            { data: "state" },
            {
              data: "cup_per_capita_per_day",
              render: $.fn.dataTable.render.number(",", ".", 1, ""),
            },
          ],
          drawCallback: function () {
            new PerfectScrollbar("#daily-cup-per-capita-table_wrapper .dataTables_scrollBody", {
              wheelSpeed: 2,
              wheelPropagation: true,
            })
          },
        })
      }

      if ($("#total-cup-in-a-life-time-table").length) {
        var usData3 = usData.sort(function (a, b) {
          return b.number_of_coffee_cups_in_a_lifetime - a.number_of_coffee_cups_in_a_lifetime
        })

        var table3 = $("#total-cup-in-a-life-time-table").DataTable({
          searching: false,
          paging: false,
          info: false,
          order: [[2, "desc"]],
          columnDefs: [
            {
              targets: [0, 1],
              orderable: false,
            },
          ],
          scrollY: 502,
          scrollCollapse: true,
          data: usData3,
          columns: [
            {
              data: null,
              render: function (data, type, full, meta) {
                var index = meta.row + 1
                var color = "16893C"
                var value = parseFloat(data.number_of_coffee_cups_in_a_lifetime)

                if (value > 5 * 1e4) {
                  color = "F9491B"
                } else if (value >= 4 * 1e4 && value <= 5 * 1e4) {
                  color = "FC8D1C"
                } else if (value >= 3 * 1e4 && value < 4 * 1e4) {
                  color = "F9B609"
                } else if (value >= 2 * 1e4 && value < 3 * 1e4) {
                  color = "91C439"
                }

                return '<span class="dot" style="--color: #' + color + '">' + index + "</span>"
              },
            },
            { data: "state" },
            {
              data: "number_of_coffee_cups_in_a_lifetime",
              render: function (data, type, full, meta) {
                return '<span class="cup">' + $.fn.dataTable.render.number(",", ".", 0, "").display(data) + "</span>"
              },
            },
          ],
          drawCallback: function () {
            new PerfectScrollbar("#total-cup-in-a-life-time-table_wrapper .dataTables_scrollBody", {
              wheelSpeed: 2,
              wheelPropagation: true,
            })
          },
        })
      }

      if ($("#coffee-price-by-states-table").length) {
        var usData3 = usData.sort(function (a, b) {
          return b.coffee_price - a.coffee_price
        })

        $("#coffee-price-by-states-table").DataTable({
          searching: false,
          paging: false,
          info: false,
          order: [[2, "desc"]],
          columnDefs: [
            {
              targets: [0, 1],
              orderable: false,
            },
          ],
          scrollY: 502,
          scrollCollapse: true,
          data: usData3,
          columns: [
            {
              data: null,
              render: function (data, type, full, meta) {
                var index = meta.row + 1
                var color = "16893C"
                var value = parseFloat(data.coffee_price)

                if (value > 4.5) {
                  color = "F9491B"
                } else if (value >= 4 && value <= 4.5) {
                  color = "F9B609"
                }

                return '<span class="dot" style="--color: #' + color + '">' + index + "</span>"
              },
            },
            { data: "state" },
            {
              data: "coffee_price",
              render: function (data, type, full, meta) {
                return "$" + $.fn.dataTable.render.number(",", ".", 2, "").display(data)
              },
            },
          ],
          drawCallback: function () {
            new PerfectScrollbar("#coffee-price-by-states-table_wrapper .dataTables_scrollBody", {
              wheelSpeed: 2,
              wheelPropagation: true,
            })
          },
        })
      }

      if ($("#total-lifetime-coffee-spending-table").length) {
        var usData3 = usData.sort(function (a, b) {
          return b.lifetime_pay - a.lifetime_pay
        })

        $("#total-lifetime-coffee-spending-table").DataTable({
          searching: false,
          paging: false,
          info: false,
          order: [[2, "desc"]],
          columnDefs: [
            {
              targets: [0, 1],
              orderable: false,
            },
          ],
          scrollY: 502,
          scrollCollapse: true,
          data: usData3,
          columns: [
            {
              data: null,
              render: function (data, type, full, meta) {
                var index = meta.row + 1
                var color = "16893C"
                var value = parseFloat(data.lifetime_pay)

                if (value > 2 * 1e5) {
                  color = "F9491B"
                } else if (value >= 1.4 * 1e5 && value <= 2 * 1e5) {
                  color = "F9B609"
                } else if (value >= 9 * 1e4 && value < 1.4 * 1e5) {
                  color = "91C439"
                }

                return '<span class="dot" style="--color: #' + color + '">' + index + "</span>"
              },
            },
            { data: "state" },
            {
              data: "lifetime_pay",
              render: function (data, type, full, meta) {
                return '<span class="dollar">$</span> ' + $.fn.dataTable.render.number(",", ".", 2, "").display(data)
              },
            },
          ],
          drawCallback: function () {
            new PerfectScrollbar("#total-lifetime-coffee-spending-table_wrapper .dataTables_scrollBody", {
              wheelSpeed: 2,
              wheelPropagation: true,
            })
          },
        })
      }

      const tableSwiper = new Swiper("#states-drink .states-drink__table .swiper", {
        loop: false,
        allowTouchMove: false,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
      })

      const mapSwiper = new Swiper("#states-drink .states-drink__map .swiper", {
        loop: false,
        allowTouchMove: false,
        effect: "fade",
        initialSlide: 2,
        fadeEffect: {
          crossFade: true,
        },
        thumbs: {
          swiper: tableSwiper,
        },
      })

      mapSwiper.on("slideChange", function () {
        var index = mapSwiper.activeIndex

        $("#states-drink .states-drink__nav > li > button").removeClass("active")
        $("#states-drink .states-drink__nav > li:nth-child(" + (index + 1) + ") > button").addClass("active")
      })

      $("#states-drink .states-drink__nav > li > button").on("click", function (e) {
        e.preventDefault()
        var index = $(this).parent().index()

        mapSwiper.slideTo(index)
      })
    }

    statesDrink()

    function animeInit() {
      $("#welcome").waypoint(
        function () {
          var tl = anime.timeline({
            easing: "linear",
            duration: 400,
          })

          tl.add({
            targets: "#welcome .welcome__heading",
            opacity: 1,
            translateY: [30, 0],
          })

          tl.add({
            targets: "#welcome .welcome__text",
            opacity: 1,
            translateY: [30, 0],
          })

          this.destroy()
        },
        {
          offset: "70%",
        },
      )

      $("#key-findings").waypoint(
        function () {
          var tl = anime.timeline({
            easing: "linear",
            duration: 300,
          })

          for (var i = 1; i <= 8; i++) {
            tl.add({
              targets: "#key-findings .item--" + i,
              opacity: 1,
              translateY: [20, 0],
            })
          }

          this.destroy()
        },
        {
          offset: "70%",
        },
      )

      $("#methodology").waypoint(
        function () {
          var tl = anime.timeline({
            easing: "linear",
            duration: 300,
          })

          $("#methodology .item").each(function () {
            tl.add({
              targets: $(this)[0],
              opacity: 1,
              translateY: [20, 0],
            })
          })

          this.destroy()
        },
        {
          offset: "70%",
        },
      )

      $(".container > h2").each(function () {
        var $this = $(this)

        $this.waypoint(
          function () {
            anime({
              targets: $this[0],
              opacity: 1,
              translateY: [30, 0],
              easing: "linear",
              duration: 300,
            })

            this.destroy()
          },
          {
            offset: "75%",
          },
        )
      })
    }

    animeInit()
  })
})(jQuery)
